export const about = {
	title: { pl: 'O aplikacji' },
	content: {
		pl: `Moje Zdrowie + to aplikacja dedykowana osobom borykającym się z\xa0chorobami przewlekłymi takimi jak: 
		POCHP, przewlekła choroba wieńcowa, cukrzyca typu\xa02, niedoczynność tarczycy, nadciśnienie tętnicze.
		Celem aplikacji jest umożliwienie pacjentowi kontrolowania swojego stanu zdrowia, co w\xa0efekcie ma zminimalizować skutki choroby.`
	},
	button: { pl: 'Pobierz' }
};
